/* eslint-disable */
import React from 'react';
import './GetPower.css';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../shared/ui';
import { formatOcppStopDetail } from './ocppStopMessage';

export default function Congrats({
  kWtCharged,
  carKwtKmRatio,
  stationNumber,
  station,
  hideUah = false,
  ocppStopReason,
  ocppErrorCode,
  ocppErrorInfo,
  ocppVendorErrorCode,
}) {
  const { t } = useTranslation();
  const chargedKwh = Math.max(0, Number(kWtCharged) || 0);
  const consumptionWhPerKm = Number(carKwtKmRatio);
  const estimatedKm =
    Number.isFinite(consumptionWhPerKm) && consumptionWhPerKm > 0
      ? Math.round((chargedKwh * 1000) / consumptionWhPerKm)
      : 0;
  const rateCents = Number(station?.costPerKwt);
  const spentUah = Number.isFinite(rateCents) ? ((rateCents * chargedKwh) / 100).toFixed(2) : '0.00';
  const ocppDetail = formatOcppStopDetail({ ocppErrorCode, ocppErrorInfo, ocppStopReason });
  const ocppTitle =
    ocppVendorErrorCode && String(ocppVendorErrorCode).trim() ? String(ocppVendorErrorCode).trim() : undefined;

  return (
    <main id="offlineStationContainer" className="session-result">
      <section id="offlineStationBox" className="session-result__card" aria-labelledby="session-result-title">
        <header className="session-result__header">
          <span className="session-result__check" aria-hidden="true">
            ✓
          </span>
          <div>
            <p className="session-result__eyebrow">{t('chargedCongrats')}</p>
            <h1 id="session-result-title" className="session-result__title">
              {t('charging')}
            </h1>
          </div>
        </header>

        <div className={`session-result__metrics${hideUah ? ' session-result__metrics--single' : ''}`}>
          <article className="session-result__metric">
            <span className="session-result__metric-label">{t('charging')}</span>
            <p className="session-result__metric-value">
              {chargedKwh.toFixed(2)}
              <span>{t('wt')}</span>
            </p>
            <p className="session-result__metric-note">
              ≈ {estimatedKm}
              {t('km')}
            </p>
          </article>

          {!hideUah ? (
            <article className="session-result__metric">
              <span className="session-result__metric-label">{t('spent')}</span>
              <p className="session-result__metric-value">
                {spentUah}
                <span>{t('currency')}</span>
              </p>
            </article>
          ) : null}
        </div>

        {ocppDetail ? (
          <p className="session-result__ocpp-stop" title={ocppTitle}>
            {t('stationStoppedCharging', { detail: ocppDetail })}
          </p>
        ) : null}

        <div className="session-result__actions">
          <Button className="session-result__action" link={`/start?station=${stationNumber}`}>
            {t('startNew')}
          </Button>
          <Button className="session-result__action" variant="outline" link="/history">
            {t('history')}
          </Button>
        </div>
      </section>
    </main>
  );
}
